export default __webpack_public_path__ + "static/media/ms.08be9db5.png";